module.exports = __webpack_public_path__ + "static/media/upper_Skrivehastighet Intro.bc33e63f.mp3";